<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <navbar>
            <template v-slot:navbarname>
                <b-link
                        :to="{name:'ProductsList',params:{'categoryid':$route.params.categoryid}}"
                        class="btn btn-primary btn-round">
                    back
                </b-link>
            </template>
        </navbar>
        <!--END Navbar-->

        <h2>Neues Produkt für die <span>"{{categoryItem.title}}"</span> kategorie
        </h2>

        <b-card title="Sub Category">
            <b-form-group label="select">
                <b-form-select
                        v-model="form.subCategory"
                        :options="categoryItem.subCategories"
                        class="mb-3"
                        value-field="id"
                        text-field="title"
                ></b-form-select>
            </b-form-group>
        </b-card>

        <b-card title="Image">
            <b-row>
                <b-col cols="12" md="6">
                    <b-form-group
                            class="required"
                            :state="!validation.hasError('image')"
                            :invalid-feedback="validation.errorTitle('image')"
                            label="thumb image">
                        <template v-if="previewUrl !== null">
                            <b-img :src="previewUrl" width="150"></b-img>
                        </template>
                        <b-form-file @change="onSelectFile" v-model="form.image"></b-form-file>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group
                            class="required"
                            :state="!validation.hasError('image_cover')"
                            :invalid-feedback="validation.errorTitle('image_cover')"
                            label="cover image">
                        <template v-if="previewCoverUrl !== null">
                            <b-img :src="previewCoverUrl" width="150"></b-img>
                        </template>
                        <b-form-file @change="onSelectFileCover" v-model="form.image_cover"></b-form-file>
                    </b-form-group>
                </b-col>
            </b-row>


            <b-form-group label="Bilder">
                <b-form-file id="images" @change="onSelectFiles" multiple></b-form-file>
            </b-form-group>

            <template v-if="form.images.length">
                <b-row>
                    <b-col
                            v-for="(image,index) in imagesPreview"
                            :key="index"
                            cols="12" md="3">
                        <b-card>
                            <b-img :src="image.url" height="85"></b-img>
                            <p>
                                <b-link class="text-danger" @click.prevent="removeImage(image)">
                                    delete
                                </b-link>
                            </p>
                        </b-card>
                    </b-col>
                </b-row>
            </template>

        </b-card>


        <b-card title="Information">
            <b-form-group
                    class="required"
                    label="Titel"
                    :state="!validation.hasError('title')"
                    :invalid-feedback="validation.errorTitle('title')"
            >
                <b-input v-model="form.title"></b-input>
            </b-form-group>
            <b-form-group
                    class="required"
                    label="seo url"
                    :state="!validation.hasError('title_seo')"
                    :invalid-feedback="validation.errorTitle('title_seo')"
            >
                <b-input placeholder="lordofhanf.com/product/" v-model="form.title_seo"></b-input>
            </b-form-group>
            <b-form-group
                    label="Preisschild"
                    :state="!validation.hasError('price_label')"
                    :invalid-feedback="validation.errorTitle('price_label')"
            >
                <b-input v-model="form.price_label"></b-input>
            </b-form-group>
            <b-form-group
                    label="CBD"
                    :state="!validation.hasError('cbd')"
                    :invalid-feedback="validation.errorTitle('cbd')"
            >
                <b-input v-model="form.cbd"></b-input>
            </b-form-group>
            <b-form-group
                    label="CBG"
                    :state="!validation.hasError('cbg')"
                    :invalid-feedback="validation.errorTitle('cbg')"
            >
                <b-input v-model="form.cbg"></b-input>
            </b-form-group>
            <b-form-group
                    label="THC"
                    :state="!validation.hasError('thc')"
                    :invalid-feedback="validation.errorTitle('thc')"
            >
                <b-input v-model="form.thc"></b-input>
            </b-form-group>
        </b-card>

        <b-card title="Description">
            <b-form-group
                    class="required"
                    label="Beschreibung"
                    :state="!validation.hasError('description')"
                    :invalid-feedback="validation.errorTitle('description')"
            >
                <tinymce id="d1" :other_options="optionsEditor" v-model="form.description"></tinymce>
            </b-form-group>
            <b-form-group
                    label="Paketbeschreibung"
                    :state="!validation.hasError('description_package')"
                    :invalid-feedback="validation.errorTitle('description_package')"
            >
                <tinymce id="d2" :other_options="optionsEditor" v-model="form.description_package"></tinymce>
            </b-form-group>
        </b-card>
        <!--END Information-->

        <b-card title="Google SEO">
            <b-form-group label="Product Number">
                <b-input v-model="form.product_number"></b-input>
            </b-form-group>
            <b-form-group label="Brand">
                <b-input v-model="form.brand"></b-input>
            </b-form-group>
            <b-form-group label="Meta Title">
                <b-input v-model="form.meta_title"></b-input>
            </b-form-group>
            <b-form-group label="Beschreibung Seo">
                <tinymce id="d3" :other_options="optionsEditor" v-model="form.seocontent"></tinymce>
            </b-form-group>
        </b-card>
        <!--END Google SEO-->

        <b-card title="Options">
            <b-row>
                <b-col cols="12" md="6">
                    <b-form-checkbox v-model="form.is_biologisch">is preisschild ?</b-form-checkbox>
                    <b-form-checkbox v-model="form.is_new">is neu ?</b-form-checkbox>
                    <b-form-checkbox v-model="form.is_hidden">is hide ?</b-form-checkbox>
                    <b-form-checkbox v-model="form.is_comingsoon">is Bald im Sortiment ?
                    </b-form-checkbox>
                    <b-form-radio
                            id="radio-1"
                            name="package"
                            :value="myTrue"
                            @change="onChangePackageType('package')">
                        produkt is selectable packet ?
                    </b-form-radio>
                    <b-form-radio
                            id="radio-3"
                            name="package"
                            :value="myTrue"
                            @change="onChangePackageType('packageCustomNames')">
                        produkt is selectable packet (custom names) ?
                    </b-form-radio>
                    <b-form-radio
                            id="radio-2"
                            name="package"
                            :value="myTrue"
                            @change="onChangePackageType('packageItems')">
                        is packet & saved items default (without select)
                    </b-form-radio>
                    <b-form-checkbox v-model="form.is_top_seller">is beseller ?
                    </b-form-checkbox>


                    <template v-if="form.is_package || form.is_hide_package_items">
                        <b-link class="text-danger" @click="removePackageFilter">remove package</b-link>
                    </template>


                    <b-form-checkbox v-model="form.is_custom_badge">is custom badge ?</b-form-checkbox>
                    <b-form-checkbox v-model="form.is_advertising">Advertising (Adcell) ?</b-form-checkbox>

                    <template v-if="form.is_custom_badge">
                        <b-form-group
                                label="badge title"
                        >
                            <b-input v-model="form.custom_badge_title"></b-input>
                        </b-form-group>

                        <b-form-group
                                label="badge text"
                        >
                            <b-input v-model="form.custom_badge_text"></b-input>
                        </b-form-group>
                    </template>
                </b-col>

                <b-col cols="12" md="6">
                    <b-form-group
                            class="required"
                            label="Inventurzählung"
                            :state="!validation.hasError('inventory_count')"
                            :invalid-feedback="validation.errorTitle('inventory_count')"
                    >
                        <b-input type="number" v-model.number="form.inventory_count"></b-input>
                    </b-form-group>
                    <b-form-group
                            class="required"
                            label="Tax">
                        <b-form-select v-model="form.tax">
                            <b-form-select-option value="10">10%</b-form-select-option>
                            <b-form-select-option value="13">13%</b-form-select-option>
                            <b-form-select-option value="20">20%</b-form-select-option>
                        </b-form-select>
                    </b-form-group>

                    <b-form-group
                            label="Rabatt Prozent"
                            :state="!validation.hasError('is_offer')"
                            :invalid-feedback="validation.errorTitle('is_offer')"
                    >
                        <b-form-select
                                @change="onSelectOfferType"
                                v-model="form.is_offer" class="mb-3">
                            <b-form-select-option value="no">No discount</b-form-select-option>
                            <b-form-select-option value="yes">yes</b-form-select-option>
                            <b-form-select-option value="init">Discount within the calculated product
                            </b-form-select-option>
                        </b-form-select>

                        <b-input class="required" type="number" placeholder="ex : 10"
                                 v-model.number="form.offer_inp"
                                 v-if="form.is_offer === 'yes'"
                        ></b-input>

                    </b-form-group>

                    <b-form-group label="Preise sortieren">
                        <b-form-select v-model="form.is_order_type">
                            <b-form-select-option value="titleAZ">Price Title A - Z</b-form-select-option>
                            <b-form-select-option value="titleZA">Price Title Z - A</b-form-select-option>
                            <b-form-select-option value="priceHighToLow">Price high to low</b-form-select-option>
                            <b-form-select-option value="priceLowToHigh">Price low to high</b-form-select-option>
                        </b-form-select>
                    </b-form-group>


                    <template v-if="form.is_package || form.is_hide_package_items">
                        <b-form-group label="select package count">
                            <b-input type="number" v-model.number="form.select_package_count"></b-input>
                        </b-form-group>
                    </template>


                </b-col>
            </b-row>

          <b-row>
            <b-col cols="12" md="12">
              <b-form-group
                  label="Out of stock message">
                <tinymce id="outOfStock" :other_options="optionsEditor" v-model="form.product_out_stock_message"></tinymce>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
        <!--END Options-->

        <b-card title="Packages">
            <template v-if="form.is_hide_package_items || form.is_package">
                <b-row>
                    <b-col cols="12" md="3">
                        <b-form-group label="titel">
                            <b-input v-model="packageItem.title"></b-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="3">
                        <b-form-group label="select product">
                            <v-select
                                    class="bg-white"
                                    placeholder="select product"
                                    label="product_title"
                                    :reduce="product_title => product_title.product_id"
                                    v-model="packageItem.product_id"
                                    :options="products"></v-select>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="2">
                        <b-form-group label="decrement count">
                            <b-input v-model="packageItem.count"></b-input>

                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="2">
                        <b-form-group label="show/hide">
                            <b-form-checkbox v-model="packageItem.isHide">is hide ?</b-form-checkbox>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="4">
                        <b-form-group label="is custom title ?">
                            <b-form-checkbox v-model="packageItem.isCustomTitle">
                                Show for this product?
                            </b-form-checkbox>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="2">
                        <b-button v-if="form.is_hide_package_items || packageItem.isCustomTitle" variant="success"
                                  @click="addPackageItem">
                            {{$t('saveTitle')}}
                        </b-button>
                        <b-button v-else-if="form.is_package" variant="success" @click="storePackage">
                            {{$t('saveTitle')}}
                        </b-button>
                    </b-col>
                </b-row>


                <packages :packages="packages" :isServer="myFalse" :isTab="myFalse"></packages>
                <!--Items-->
            </template>

            <template v-else-if="form.is_package">
                <hr>
                <packages :packages="packages" :isServer="form.is_package" :isTab="myTrue"></packages>
            </template>
            <!--From Server-->


        </b-card>
        <!--END Packages-->

        <b-card title="Prise">
            <b-row>
                <b-col cols="12" md="2">
                    <b-form-group label="select prise type">
                        <b-form-select @input="onSelectPriceType">
                            <b-form-select-option value="gram">Gram</b-form-select-option>
                            <b-form-select-option value="gram_offer">Gram Discount</b-form-select-option>
                            <b-form-select-option value="single_price">Single Prise</b-form-select-option>
                            <b-form-select-option value="single_price_offer">Single Prise Discount
                            </b-form-select-option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="3" v-if="isPriceGram">
                    <b-form-group label="Abnehmen aus dem Lager">
                        <b-input v-model.number="priceItem.amountgram" type="number"></b-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="4" v-if="isPriceGram">
                    <b-form-group label="Titel">
                        <b-input v-model="priceItem.title"></b-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="3"
                       v-if="isPriceOffer">
                    <b-form-group label="Rabbat Percent">
                        <b-input v-model.number="priceItem.offerDiscount" type="number"></b-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="2">
                    <b-form-group label="price">
                        <b-input v-model.number="priceItem.price" type="number"></b-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="2"
                       v-if="priceItem.priceType === 'single_price_offer' || priceItem.priceType === 'gram_offer'">
                    <b-form-group label="price sell">
                        <b-input v-model.number="priceItem.priceSell" type="number"></b-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="3">
                    <b-form-group label="Mit Rabatt anzeigen?">
                        <b-form-checkbox v-model="priceItem.priceGroup">Mit Rabatt anzeigen?</b-form-checkbox>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="3">
                    <b-form-group label="is Hide?">
                        <b-form-checkbox v-model="priceItem.isHide">is Hide?</b-form-checkbox>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-button variant="info" @click="addPriceItem">add</b-button>


            <Prices :prices="prices" :isServer="false"></Prices>
            <!--Get Prices-->
        </b-card>
        <!--END Prices-->


        <b-button variant="success" @click="storeProduct">{{$t('saveTitle')}}</b-button>


    </div>
</template>

<script>
    import Navbar from "../Partials/Navbar";
    import Http from '../../Services/HttpService/HttpService'
    import Notification from '../../Services/Notification/Nottification'
    import Validation from '../../Services/Validation/Validation'
    import Prices from "./Components/Prices";
    import 'vue-select/dist/vue-select.css';
    import Package from "./Components/Package";
    import Packages from "./Components/Packages";
    import {EventBus} from "../../Services/Eventbus/event-bus";


    export default {
        name: "AddProduct",
        components: {
            // Package,
            Packages,
            Prices,
            Navbar,
        },
        data() {
            return {
                myFalse: false,
                myTrue: true,
                number: 1,
                validation: new Validation(),
                previewUrl: null,
                previewCoverUrl: null,
                imagesPreview: [],
                categoryItem: {
                    title: null,
                    subCategories: []
                },
                form: {
                    subCategory: null,
                    category: null,
                    title: null,
                    meta_title: null,
                    title_seo: null,
                    price_label: '',
                    inventory_count: null,
                    cbd: null,
                    cbg: null,
                    thc: null,
                    is_offer: "no",
                    is_gram: true,
                    is_biologisch: false,
                    is_single_price: false,
                    is_custom_stock_count: false,
                    is_hidden: false,
                    is_new: false,
                    is_hide_package_items: false,
                    is_comingsoon: false,
                    is_package: false,
                    is_package_custom_names: false,
                    is_order_type: false,
                    is_top_seller: false,
                    is_custom_badge: false,
                    is_advertising: false,
                    custom_badge_title: null,
                    custom_badge_text: null,
                    offer_inp: 0,
                    tax: null,
                    select_package_count: 5,
                    description: null,
                    brand: null,
                    product_number: null,
                    description_package: null,
                    product_out_stock_message: null,
                    seocontent: null,
                    image: null,
                    image_cover: null,
                    images: [],
                },
                priceItem: {
                    amountgram: 1,
                    title: null,
                    price: null,
                    priceSell: null,
                    priceType: 'gram',
                    priceGroup: false,
                    isHide: false,
                    offerDiscount: 0,
                },
                prices: [],
                packages: [],
                products: [],
                packageItem: {
                    title: null,
                    product_id: null,
                    isHide: false,
                    isCustomTitle: false,
                    count: 1,
                },
                optionsEditor: {
                    height: 300,
                    toolbar: [
                        'formatselect | fontsizeselect | fontselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | removeformat | bootstrap4grid'
                    ]
                },
            }
        },
        computed: {
            isPriceGram() {
                return this.priceItem.priceType === 'gram' || this.priceItem.priceType === 'gram_offer';
            },
            isPriceOffer() {
                return this.priceItem.priceType === 'single_price_offer' || this.priceItem.priceType === 'gram_offer';
            },
        },
        methods: {
            removePackageFilter() {
                this.form.is_package = false;
                this.form.is_hide_package_items = false;
            },
            storeProduct() {
                if (this.prices.length) {
                    let fd = new FormData();

                    fd.append('sub_category', this.form.subCategory);
                    fd.append('category', this.$route.params.categoryid);
                    fd.append('title', this.form.title);
                    fd.append('meta_title', this.form.meta_title);
                    fd.append('title_seo', this.form.title_seo);
                    fd.append('price_label', this.form.price_label);
                    fd.append('inventory_count', this.form.inventory_count);
                    fd.append('cbd', this.form.cbd);
                    fd.append('cbg', this.form.cbg);
                    fd.append('thc', this.form.thc);
                    fd.append('is_offer', this.form.is_offer);
                    fd.append('is_comingsoon', this.form.is_comingsoon);
                    fd.append('is_gram', this.form.is_gram);
                    fd.append('is_biologisch', this.form.is_biologisch);
                    fd.append('is_new', this.form.is_new);
                    fd.append('is_single_price', this.form.is_single_price);
                    fd.append('is_hidden', this.form.is_hidden);
                    fd.append('is_hide_package_items', this.form.is_hide_package_items);
                    fd.append('is_package', this.form.is_package);
                    fd.append('is_order_type', this.form.is_order_type);
                    fd.append('is_top_seller', this.form.is_top_seller);
                    fd.append('is_custom_stock_count', this.form.is_custom_stock_count);
                    fd.append('is_custom_badge', this.form.is_custom_badge);
                    fd.append('is_advertising', this.form.is_advertising);
                    fd.append('custom_badge_title', this.form.custom_badge_title);
                    fd.append('custom_badge_text', this.form.custom_badge_text);
                    fd.append('offer_inp', this.form.offer_inp);
                    fd.append('tax', this.form.tax);
                    fd.append('select_package_count', this.form.select_package_count);
                    fd.append('description', this.form.description);
                    fd.append('description_package', this.form.description_package);
                    fd.append('seocontent', this.form.seocontent);
                    fd.append('image', this.form.image);
                    fd.append('prices', JSON.stringify(this.prices));
                    fd.append('image', this.form.image);
                    fd.append('image_cover', this.form.image_cover);
                    fd.append('brand', this.form.brand);
                    fd.append('product_number', this.form.product_number);
                    fd.append('product_out_stock_message', this.form.product_out_stock_message);

                    if (this.form.is_package_custom_names || this.form.is_hide_package_items) {
                        fd.append('packages', JSON.stringify(this.packages));
                    }

                    if (this.form.images.length) {
                        this.form.images.map(photo => fd.append('images[]', photo, photo.name));
                    }

                    this.$Progress.start();
                    Http.post(Http.apiurlV2() + 'product/store', fd, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                    })
                        .then(response => {
                            this.$Progress.finish();
                            if (response.data.status_code === Http.created()) {
                                Notification.success(response.data.message);
                                this.$router.push({
                                    name: 'ProductsList',
                                    params: {'categoryid': this.$route.params.categoryid}
                                });
                            } else {
                                this.validation.store(response.data.data);
                                Notification.error(response.data.message)

                            }
                        })
                        .catch(error => {
                            this.$Progress.finish();
                        })


                } else {
                    Notification.error("Enter Prices")
                }
            },
            onChangePackageType(myType) {
                switch (myType) {
                    case 'package':
                        this.form.is_hide_package_items = false;
                        this.form.is_package = true;
                        this.packages = [];
                        this.getPackageItems();
                        break;
                    case 'packageItems':
                        this.form.is_package = false;
                        this.form.is_hide_package_items = true;
                        this.packages = [];
                        break;
                    case 'packageCustomNames':
                        this.form.is_package_custom_names = true;
                        this.form.is_package = true;
                        this.form.is_hide_package_items = false;
                        this.packages = [];
                        break;
                }
            },
            deletePriceItemValues() {
                this.priceItem.amountgram = 0;
                this.priceItem.offerDiscount = 0;
                this.priceItem.stockCount = 0;
                this.priceItem.title = null;
                this.priceItem.price = null;
                this.priceItem.priceSell = null;
                this.priceItem.priceGroup = false;
                this.priceItem.isHide = false;
            },
            deletePackageItemValues() {
                this.packageItem.id = 0;
                this.packageItem.title = null;
                this.packageItem.count = 1;
                this.packageItem.product_id = null;
                this.packageItem.isHide = false;
                this.packageItem.isCustomTitle = false;
            },
            onSelectPriceType(myValue) {
                this.priceItem.priceType = myValue;
                this.deletePriceItemValues();
                switch (myValue) {
                    case "gram":
                        this.form.is_gram = true;
                        this.form.is_single_price = false;
                        break;
                    case "gram_offer":
                        this.form.is_gram = true;
                        this.form.is_single_price = false;
                        // this.priceItem.priceGroup = true;
                        break;
                    case "single_price":
                        this.form.is_gram = false;
                        this.form.is_single_price = true;
                        break;
                    case "single_price_offer":
                        this.form.is_gram = false;
                        this.form.is_single_price = true;
                        // this.priceItem.priceGroup = true;
                        break;
                }
            },
            addPriceItem() {
                this.prices.push({
                    id: this.number++,
                    groupId: null,
                    title: this.priceItem.title,
                    price: this.priceItem.price,
                    priceSell: this.priceItem.priceSell,
                    type: this.priceItem.priceType,
                    gram: this.priceItem.amountgram,
                    offerDiscount: this.priceItem.offerDiscount,
                    priceGroup: this.priceItem.priceGroup,
                    isHide: this.priceItem.isHide,
                });
                this.deletePriceItemValues();
            },
            onSelectOfferType() {
                if (this.form.is_offer === 'init' || this.form.is_offer === 'no') {
                    this.form.offer_inp = 0;
                }
            },
            onSelectFiles(e) {
                this.form.images = [];
                this.imagesPreview = [];

                var files = e.target.files || e.dataTransfer.files;
                if (!files.length)
                    return;
                for (var i = files.length - 1; i >= 0; i--) {
                    this.form.images.push(files[i]);
                    this.imagesPreview.push({
                        id: i,
                        url: URL.createObjectURL(files[i])
                    });
                }
                document.getElementById("images").value = [];

            },
            removeImage(image) {
                let imageItem = this.imagesPreview.find(item => item.id === image.id);
                if (imageItem) {
                    this.form.images.splice(this.form.images.indexOf(image), 1);
                    this.imagesPreview.splice(this.imagesPreview.indexOf(image), 1);
                } else {
                    alert('Image Not Found')
                }

            },
            onSelectFile(event) {
                this.previewUrl = URL.createObjectURL(event.target.files[0]);
            },
            onSelectFileCover(event) {
                this.previewCoverUrl = URL.createObjectURL(event.target.files[0]);
            },
            addPackageItem() {
                this.packages.push({
                    id: this.number++,
                    is_hide: this.packageItem.isHide,
                    is_show_product: this.form.is_hide_package_items,
                    is_custom_title: this.packageItem.isCustomTitle,
                    product_id: this.packageItem.product_id,
                    title: this.packageItem.title,
                    count: this.packageItem.count,
                });

                this.deletePackageItemValues();
            },
            storePackage() {
                if (this.packageItem.title === null) {
                    Notification.error("package title is required")
                } else {
                    this.$Progress.start();
                    Http.post(Http.apiurlV2() + 'product/package/store/' + this.$route.params.categoryid, {
                        'is_hide': this.packageItem.isHide,
                        'is_custom_title': this.packageItem.isCustomTitle,
                        'is_show_product': false,
                        'product_id': this.packageItem.product_id,
                        'count': this.packageItem.count,
                        'title': this.packageItem.title
                    })
                        .then(response => {
                            if (response.data.status_code === Http.created()) {
                                this.$Progress.finish();
                                this.getPackageItems();
                                this.deletePackageItemValues();
                                Notification.success(response.data.message)
                            }
                        })
                        .catch(error => {
                            this.$Progress.finish();
                        })
                }

            },
            getPackageItems() {
                this.$Progress.start();
                let url;
                url = Http.apiurl() + 'package/index/' + this.$route.params.categoryid;

                Http.get(url)
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.ok()) {
                            this.packages = [];
                            this.packages = response.data.data;
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            getPackageProductItems() {
                this.$Progress.start();
                Http.get(Http.apiurlV2() + 'product/package/get/products')
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.ok()) {
                            this.products = response.data.data;
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            getCategory() {
                this.$Progress.start();
                let url;
                url = Http.apiurlV2() + 'product/create/' + this.$route.params.categoryid;

                Http.get(url)
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.ok()) {
                            this.categoryItem.title = response.data.data.categoryTitle;
                            this.categoryItem.subCategories = response.data.data.items;
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
        },
        created() {
            this.getPackageItems();
            this.getPackageProductItems();
            this.getCategory();
        },
        mounted() {
            let myThis = this;
            EventBus.$on('updatePackage', function (payload) {
                if (payload === 'yes') {
                    myThis.getPackageItems()
                }
            });
        }
    }
</script>

<style scoped>

</style>